import { useEffect, useState } from 'react';
import { GridUsersDropdown } from '../../grid/GridUsersDropdown';
import { UsersDto } from 'users-experience-client';
import { GridDropdown } from '../../grid/GridDropdown';
import { ClinicalFormInfo } from 'clinical-forms-experience-client';
import { ClinicalFormsConstants } from '../ClinicalForms/ClinicalFormsConstants';
import { IdValuePairDTO } from 'common-util-experience-client';
import { UserContextHolder } from '../../auth/UserContextHolder';
import { getAllClinicalForms, useAssessmentParams } from './apiUtils.assessment';
import { useNavigate } from 'react-router-dom';
import { navigateToAssessment } from "./utils.assessment";

// NEW INTERFACE FOR FILTERS
export interface AssessmentFilters {
  searchText: string;
  completedBy: string[];
  assessmentType: string[];
  assessmentStatus: string[];
}

interface AssessmentHeaderProps {
  onUpdateFilters: (filters: AssessmentFilters) => void;
}

const AssessmentHeader = (props: AssessmentHeaderProps) => {
  const [searchText, setSearchText] = useState<string>("");
  const [completedBy, setCompletedBy] = useState<string[] | null>(null);
  const [assessmentType, setAssessmentType] = useState<ClinicalFormInfo[]>([]);
  const [initialKeys, setInitialKeys] = useState<string[]>([
    ClinicalFormsConstants.draftStatus, 
    ClinicalFormsConstants.submittedStatus
  ]);
  const [assessmentStatus, setAssessmentStatus] = useState<IdValuePairDTO[]>([
    {
      id: ClinicalFormsConstants.draftStatus,
      value: "Draft"
    },
    {
      id: ClinicalFormsConstants.submittedStatus,
      value: "Submitted"
    }
  ]);

  const {patientId} = useAssessmentParams();

  const navigate = useNavigate();
 
  // Build the new filter object based on the current state values
  const updateFilters = () => {
    const newFilters: AssessmentFilters = {
      searchText: searchText || "",
      completedBy: completedBy ? completedBy : [],
      assessmentType: assessmentType && assessmentType.length > 0 ? assessmentType.map(p => p.id) : [],
      assessmentStatus: assessmentStatus && assessmentStatus.length > 0 ? assessmentStatus.map(p => p.id) : []
    };
    props.onUpdateFilters(newFilters);
  };

  useEffect(updateFilters, [searchText, assessmentType, completedBy, assessmentStatus]);

const updateCompletedBy = (values: UsersDto[]) => {
    const currentUser: UsersDto = UserContextHolder.getUser()!;
    if (values) {
        const updatedValues = values.map(v =>
        v.id === currentUser.id
            ? `${currentUser.firstName} ${currentUser.lastName}`
            : `${v.firstName} ${v.lastName}`
        );
        setCompletedBy(updatedValues);
    } else {
        setCompletedBy([]);
    }
};

const navigateToDefaultAssessmentForm = () => {
  if (!patientId) {
    console.error("Patient ID is missing");
    return;
  }

  navigateToAssessment(
    ClinicalFormsConstants.defaultFormId,
    "", // No specific assessmentTypeId for default navigation
    patientId,
    () => {}, // No need to setAllAnswersGiven in this context
    navigate
  );
};

  const loadAssessmentType = async () => {
    const response = await getAllClinicalForms();
    return response?.data || [];
  };

  // Provide an updated list of assessment status options.
  const getAssessmentStatus = async () => {
    return [
      {
        id: ClinicalFormsConstants.draftStatus,
        value: 'Draft'
      },
      {
        id: ClinicalFormsConstants.submittedStatus,
        value: 'Submitted'
      },
      {
        id: ClinicalFormsConstants.discardedStatus,
        value: 'Discarded'
      }
    ];
  };

  return (
    <>
      <div className="d-md-flex align-items-center px-3 px-md-4 px-lg-5 py-2 border-bottom">
        <div className="flex-fill d-flex align-items-center">
          <div className="search-box max-w-md-18-75">
            <span className="material-symbols-outlined search-box__icon">
              search
            </span>
            <div className="typeahead-container search-box d-flex">
              <span className="material-symbols-outlined search-box__icon">
                search
              </span>
              <input
                type="text"
                name="searchAssessment"
                className="form-control search-box__input fw-normal fs-12"
                placeholder="Search Assessment"
                onChange={(event) => setSearchText(event.target.value)}
              />
            </div>
          </div>
        </div>
        <GridDropdown
          label="Assessment Type"
          keyProvider={(item) => item.id}
          labelProvider={(item) => item.title}
          dataProvider={loadAssessmentType}
          onChange={setAssessmentType}
        />
        <GridUsersDropdown
          label="Completed By"
          onChange={updateCompletedBy}
        />
        <GridDropdown
          label="Status"
          keyProvider={(item) => item.id}
          labelProvider={(item) => item.value}
          dataProvider={getAssessmentStatus}
          initialKeys={initialKeys}
          onChange={setAssessmentStatus}
        />
        <button
          className="btn btn-sm btn-secondary px-3 ms-md-2 me-2 me-md-0 mt-2 mt-md-0 rounded-pill pe-4"
          onClick={navigateToDefaultAssessmentForm}
        >
          <span className="material-symbols-outlined fs-16 align-text-top">
            add
          </span> Add Assessment
        </button>
      </div>
    </>
  );
};

export default AssessmentHeader;
